import { Frequency, FrequencyTypes, Photo } from '../../../common/models/index';

export class BackgroundPainter {
  photos: Photo[] = [
    { name: 'dew-on-leaves.jpg', description: 'Dew on leaves' },
    { name: 'dew-on-wheat.jpg', description: 'Dew on wheat' },
    { name: 'ducklings.jpg', description: 'Ducklings' },
    { name: 'ducks.jpg', description: 'Ducks' },
    { name: 'egret.jpg', description: 'Egret' },
    { name: 'fall-leaves.jpg', description: 'Fall leaves' },
    { name: 'fall-trees.jpg', description: 'Fall trees' },
    { name: 'grapes.jpg', description: 'Grapes' },
    { name: 'hawk.jpg', description: 'Hawk' },
    { name: 'lady-bug.jpg', description: 'Lady bug' },
    { name: 'purple-flowers.jpg', description: 'Purple flowers' },
    { name: 'red-flowers.jpg', description: 'Red flowers' },
    { name: 'red-sky.jpg', description: 'Red sky' },
    { name: 'squirrel.jpg', description: 'Squirrel' },
    { name: 'sunflower.jpg', description: 'Sunflower' }
  ];

  static create(): BackgroundPainter { return new BackgroundPainter(); }

  nextPhoto(rotation: Frequency): Photo {
    if (rotation === FrequencyTypes.DAILY) {
      const day = new Date().getDate();

      return this.photos[ day % this.photos.length ];
    } else if (rotation === FrequencyTypes.QUARTERLY) {
      const month = new Date().getMonth();

      return this.photos[ month % this.photos.length ];
    }

    return this.photos[0];
  }
}



// WEBPACK FOOTER //
// ./src/gs-core/client/react/layout/BackgroundPainter.ts